import { PremiumFeatures } from '~components/PremiumFeatures';
import { useTranslations } from '~i18n/hooks';

import { Container } from './styled';

export const Features = () => {
	const t = useTranslations('MySubscriptions');
	return (
		<Container>
			<PremiumFeatures title={t('featuresTitle')} />
		</Container>
	);
};
